import { defineComponent as _defineComponent } from 'vue'

    import { useTouristGroupModel } from '@entities/searchCriteria/touristGroup';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'TouristGroup',
  props: {
    size: null
  },
  setup(__props: any) {

    

    const { touristGroupText } = useTouristGroupModel();


return { __sfc: true,touristGroupText }
}

})